module.exports = __webpack_public_path__ + "img/jlxq.f6826144.gif";